import {SET_CURRENT_REQUEST} from "../../../enums/Request/request.types";

export const setCurrentRequestAction = (data) => {
    return {
        type: SET_CURRENT_REQUEST,
        payload: data,
    };
};
